// removed by extract-text-webpack-plugin
module.exports = {"icon-padding-top":"index__icon-padding-top___1dMZy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DeleteConfirmDialog/index.less
// module id = 1052
// module chunks = 3